import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "width", "primary", "secondary", "color"];
import React from 'react';
import { ChildrenPropType } from '../../../../services/proptypes';
import GridColumnFlex from '../../../GridColumnFlex';
var defaultProps = {
  children: null,
  color: 'transparent',
  primary: false,
  secondary: false,
  width: null
};

function Color(_ref) {
  var children = _ref.children,
      width = _ref.width,
      primary = _ref.primary,
      secondary = _ref.secondary,
      color = _ref.color,
      columnProps = _objectWithoutProperties(_ref, _excluded);

  var extraClasses = '';

  if (primary) {
    extraClasses = ' primary';
  } else if (secondary) {
    extraClasses = ' secondary';
  }

  var styles = primary || secondary ? {} : {
    backgroundColor: color
  };
  return /*#__PURE__*/React.createElement(GridColumnFlex, _extends({
    className: "color-component".concat(extraClasses),
    width: width,
    style: styles
  }, columnProps), children);
}

Color.defaultProps = defaultProps;
export default Color;